import OverlayTips from "../OverlayTips";

function LockTTPageOverlayTipsManager()
{
    PageOverlayTipsManager.call(this);
}

LockTTPageOverlayTipsManager.prototype = _.create(PageOverlayTipsManager.prototype, {
    addBaseTips: function()
    {
        PageOverlayTipsManager.prototype.addBaseTips.apply(this);

        this.add($(".pagetitle span"), {
            messageKey: "tips.lock_tt.title",
            direction: OverlayTips.DIRECTION_TOP_LEFT,
            offsetX: 10,
            offsetY: -10,
            outside: {
                direction: OverlayTips.DIRECTION_TOP_RIGHT
            }
        });

        var self = this;
        this.add(function()
                 {
                     var $rowTds = self._getLockTableRows().eq(1).find("td");
                     return $rowTds.length < 15 ? $rowTds.eq(-3) : $rowTds.eq(11);
                 },
                 {
                     messageKey: "tips.lock_tt.several_days",
                     direction: OverlayTips.DIRECTION_TOP_RIGHT,
                     offsetX: -30,
                     offsetY: -10
                 });

        this.add(function()
                 {
                     var $rowTds = self._getLockTableRows().eq(2).find("td");
                     return $rowTds.length < 15 ? $rowTds.eq(-2) : $rowTds.eq(12);
                 },
                 {
                     messageKey: "tips.lock_tt.date",
                     direction: OverlayTips.DIRECTION_BOTTOM_RIGHT,
                     offsetX: -10,
                     offsetY: 10
                 });

        this.add(function()
                 {
                     return self._getLockTableRows().has(".userDayCell").eqOrLast(2).find(".userDayCell").eq(4);
                 },
                 {
                     messageKey: "tips.lock_tt.cell",
                     direction: OverlayTips.DIRECTION_BOTTOM_LEFT,
                     offsetX: -10
                 });
    },

    _getLockTableRows: function()
    {
        return $("#lockTablePlaceholder").find("tr:visible");
    }
});

export default LockTTPageOverlayTipsManager;


// WEBPACK FOOTER //
// ./web/js/tips/managers/LockTTPageOverlayTipsManager.js